module.exports = __webpack_public_path__ + "img/16200.2bf6ae59.jpg";